module.exports = __webpack_public_path__ + "static/media/searching-for-a-job.aebd363b.jpg";